/* ----------------------------- */
/*   React/Redux Auth reusable utilities
/* ----------------------------- */

// library to decode JWT tokens
import {
  KJUR,
  b64utoutf8,
} from 'jsrsasign';


// decode JWTPayload from JWTToken gibberish string
const decodeJWTPayload = (JWTToken) => (KJUR.jws.JWS.readSafeJSONString(b64utoutf8(JWTToken.split('.')[1])));

// make formatted user data from decoded JWTPayload
const makeUserFromJWTPayload = (JWTPayload) => ({
  id: JWTPayload.user_id,
  firstName: JWTPayload.first_name,
  lastName: JWTPayload.last_name,
  roles: JWTPayload.roles,
  remedyIds: JWTPayload.remedy_ids,
  groups: JWTPayload.groups,
});

const makeRelayStateFromRedirectRoute = (redirectRoute) => {
  // MM: this is so it does not send us back to live server while on dev!
  const origin = window.location.origin;
  const relayState = `${origin}${redirectRoute}`;
  return relayState;
};


export {
  decodeJWTPayload,
  makeUserFromJWTPayload,
  makeRelayStateFromRedirectRoute,
};

